export default __webpack_public_path__ + "static/media/body-section-calves.2c8f21a3.png";